<template lang="html">

  <div class="notificaciones">

    <button class="show-notificaciones" @click="show = !show" v-if="!!notificaciones">
      <i class="fa fa-bell-o" aria-hidden="true"></i>
      <span v-if="sinleer.length > 0" class="cantidad row-center">{{ sinleer.length }}</span>
    </button>

    <div class="contenedor-notificaciones" v-show="show" :noHas="notificaciones.length == 0">

      <a class="borrar-todas" @click="borrarTodas" v-if="notificaciones.length > 0">{{ $t('notificaciones.borrar_todo')
      }}</a>

      <template v-if="notificaciones.length > 0">

        <div class="listado-notificaciones" v-if="!!notificaciones">

          <div class="importantes" v-if="importantes.length > 0">

            <h3 class="title-notificacion">{{ $t('notificaciones.importantes') }}</h3>

            <template v-for="(notificacion, key) in importantes">
              <notificacion :key="key" :data="notificacion"></notificacion>
            </template>


          </div>


          <div class="secundarias">

            <h3 class="title-notificacion" v-if="otras.length > 0 & importantes.length > 0">
              {{ $t('notificaciones.otras_notificaciones') }}</h3>

            <template v-for="(notificacion, key) in notificaciones">
              <notificacion :key="key" :data="notificacion"></notificacion>
            </template>

          </div>

        </div>

      </template>
      <template v-else>
        <p :style="style.colorDarkBlack">{{ $t('notificaciones.no_notificaciones') }}</p>
      </template>

    </div>

  </div>

</template>

<script lang="js">



import notificacion from '@/components/parts/notificacion';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'notificaciones',
  data() {
    return {
      show: false
    }
  },
  components: {

    'notificacion': notificacion
  },
  watch: {
    '$route': function () {
      this.show = false;
    },
    'show': function () {
      if (!this.show) {
        this.marcarNotificacionesSinEnlaceLeidas();
      }
    },
    'sinleer'() {
      if (this.sinleer.length > 0) {
        document.title = document.title + ` (${this.sinleer.length})`;
      } else {
        document.title = document.title.split(" (")[0];
      }
    }
  },
  computed: {
    ...mapGetters({
      notificaciones: 'getNotificaciones',
      colors: 'basicColors',
      style: 'getStyles'
    }),
    importantes: function () {
      let notificaciones;
      if (!!this.notificaciones) {
        notificaciones = this.notificaciones.filter(e => e.Importante);
      }
      return notificaciones;
    },
    otras: function () {
      let notificaciones;
      if (!!this.notificaciones) {
        notificaciones = this.notificaciones.filter(e => !e.Importante);
      }
      return notificaciones;
    },
    sinleer: function () {
      let notificaciones = [];
      if (!!this.notificaciones) {
        notificaciones = this.notificaciones.filter(e => !e.leida);
      }
      return notificaciones;
    },
    ownstyle: function () {
      return {
        notificaciones: {
          background: this.colors.white
        },
        cantidad: {
          background: this.colors.button,
          color: this.colors.buttonFont
        }
      }
    }
  },
  methods: {
    ...mapActions(['marcarNotificacionesSinEnlaceLeidas', 'borrarTodas'])
  }

}
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';

.notificaciones {
  position: relative;
}

.show-notificaciones {
  width: 30px;
  height: 30px;
  border: none;
  display: block;
  position: relative;
  background: $secondary;
  cursor: pointer;
  outline: none;
  border-radius: 50%;
  font-size: 19px;

  i {
    color: $primary;
  }
}

.cantidad {
  position: absolute;
  color: $primary;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  right: -10px;
  top: 0;
  font-size: 12px;
  font-weight: 700;
  -webkit-transform: translate(-20%, -30%);
  transform: translate(-20%, -30%);
}

.contenedor-notificaciones {
  width: 420px;
  position: absolute;
  height: 360px;
  display: inline-block;
  right: -17px;
  top: 45px;
  border-radius: 6px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.27);
  padding: 25px 0;
  background: $white;

  &[noHas=true] {
    height: auto;
  }
}

.contenedor-notificaciones::before {
  content: '';
  position: absolute;
  right: 20px;
  top: -24px;
  border: 12px solid transparent;
  border-bottom-color: white;
  display: inline-block;
}

[dark=true] {
  .contenedor-notificaciones {
    background: $almost-black;

    &::before {
      border-bottom-color: $almost-black;
    }
  }
}

.listado-notificaciones {
  max-height: 100%;
  overflow: scroll;
  overflow-x: hidden;
}

.listado-notificaciones::-webkit-scrollbar-track {
  background-color: transparent;
}

.listado-notificaciones::-webkit-scrollbar {
  background-color: #F5F5F5;
  width: 6px;
}

.listado-notificaciones::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #9f9f9f;
}

.title-notificacion {
  width: 100%;
  text-align: left;
  padding: 10px;
  font-size: 14px;
}

.contenedor-notificaciones>p {
  text-align: center;
  margin-bottom: 0;
  color: currentColor;
}

.borrar-todas {
  font-size: 10px;
  position: absolute;
  right: 10px;
  top: 5px;
}

@media screen and (max-width: 500px) {

  .contenedor-notificaciones {
    width: 100vw;
    height: calc(100vh - 50px);
    right: 0;
    top: 60px;
    position: fixed;
    border-radius: 0;
  }

  .contenedor-notificaciones::before {
    right: 67px;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/parts/notificaciones.vue